// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file v1/bet_limit.proto (package v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Date } from "../google/type/date_pb";
import { file_google_type_date } from "../google/type/date_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file v1/bet_limit.proto.
 */
export const file_v1_bet_limit: GenFile = /*@__PURE__*/
  fileDesc("ChJ2MS9iZXRfbGltaXQucHJvdG8SAnYxImsKCEJldExpbWl0EhIKCnN0YXRpb25faWQYASABKAUSFAoMc3RhdGlvbl9pZF8yGAIgASgFEg4KBmRpZ2l0cxgDIAEoBRIPCgdjb21tYW5kGAQgASgJEhQKDGxpbWl0X2Ftb3VudBgFIAEoASJRCgxMaW1pdFN0YXRpb24SCgoCaWQYASABKAUSDwoHd2Vla2RheRgCIAEoCRIVCg1zdGF0aW9uX2luZGV4GAMgASgFEg0KBWFsaWFzGAQgASgJIjsKFExpc3RCZXRMaW1pdHNSZXF1ZXN0EhMKC2N1c3RvbWVyX2lkGAEgASgFEg4KBnJlZ2lvbhgCIAEoCSKFAQoVTGlzdEJldExpbWl0c1Jlc3BvbnNlEhwKBmxpbWl0cxgBIAMoCzIMLnYxLkJldExpbWl0EiIKCHN0YXRpb25zGAIgAygLMhAudjEuTGltaXRTdGF0aW9uEhUKDWN1c3RvbWVyX25hbWUYAyABKAkSEwoLY29uZmlnX3R5cGUYBCABKAkicAoWVXBzZXJ0QmV0TGltaXRzUmVxdWVzdBITCgtjdXN0b21lcl9pZBgBIAEoBRIOCgZyZWdpb24YAiABKAkSHAoGbGltaXRzGAMgAygLMgwudjEuQmV0TGltaXQSEwoLY29uZmlnX3R5cGUYBCABKAkiGQoXVXBzZXJ0QmV0TGltaXRzUmVzcG9uc2UiYwoQTWVzc2FnZU92ZXJMaW1pdBISCgptZXNzYWdlX2lkGAEgASgFEg8KB2NvbnRlbnQYAiABKAkSFAoMb3Zlcl9tZXNzYWdlGAMgASgJEhQKDGtlcHRfbWVzc2FnZRgEIAEoCSJtChtHZXRPdmVyTGltaXRNZXNzYWdlc1JlcXVlc3QSEwoLY3VzdG9tZXJfaWQYASABKAUSDgoGcmVnaW9uGAIgASgJEikKDmNhbGN1bGF0ZV9kYXRlGAMgASgLMhEuZ29vZ2xlLnR5cGUuRGF0ZSJGChxHZXRPdmVyTGltaXRNZXNzYWdlc1Jlc3BvbnNlEiYKCG1lc3NhZ2VzGAEgAygLMhQudjEuTWVzc2FnZU92ZXJMaW1pdDKEAgoPQmV0TGltaXRTZXJ2aWNlEkYKDUxpc3RCZXRMaW1pdHMSGC52MS5MaXN0QmV0TGltaXRzUmVxdWVzdBoZLnYxLkxpc3RCZXRMaW1pdHNSZXNwb25zZSIAEkwKD1Vwc2VydEJldExpbWl0cxIaLnYxLlVwc2VydEJldExpbWl0c1JlcXVlc3QaGy52MS5VcHNlcnRCZXRMaW1pdHNSZXNwb25zZSIAElsKFEdldE92ZXJMaW1pdE1lc3NhZ2VzEh8udjEuR2V0T3ZlckxpbWl0TWVzc2FnZXNSZXF1ZXN0GiAudjEuR2V0T3ZlckxpbWl0TWVzc2FnZXNSZXNwb25zZSIAQihaJmdpdGh1Yi5jb20vZHVjYnQvdHQtZ28vZ2VuL3Byb3RvL3YxO3YxYgZwcm90bzM", [file_google_type_date]);

/**
 * BetLimit is one configured cap. station_id 0 is a "Tất cả" (region-wide)
 * cell; a non-zero station_id is a "Chi tiết" cell, and station_id_2 is set
 * only for dx pairs. digits is 0 for da/dx. command: lo|baylo|dau|duoi|da|dx.
 *
 * @generated from message v1.BetLimit
 */
export type BetLimit = Message<"v1.BetLimit"> & {
  /**
   * @generated from field: int32 station_id = 1;
   */
  stationId: number;

  /**
   * @generated from field: int32 station_id_2 = 2;
   */
  stationId2: number;

  /**
   * @generated from field: int32 digits = 3;
   */
  digits: number;

  /**
   * @generated from field: string command = 4;
   */
  command: string;

  /**
   * @generated from field: double limit_amount = 5;
   */
  limitAmount: number;
};

/**
 * Describes the message v1.BetLimit.
 * Use `create(BetLimitSchema)` to create a new message.
 */
export const BetLimitSchema: GenMessage<BetLimit> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 0);

/**
 * LimitStation is a station_master slot with the user's display alias.
 *
 * @generated from message v1.LimitStation
 */
export type LimitStation = Message<"v1.LimitStation"> & {
  /**
   * @generated from field: int32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string weekday = 2;
   */
  weekday: string;

  /**
   * @generated from field: int32 station_index = 3;
   */
  stationIndex: number;

  /**
   * @generated from field: string alias = 4;
   */
  alias: string;
};

/**
 * Describes the message v1.LimitStation.
 * Use `create(LimitStationSchema)` to create a new message.
 */
export const LimitStationSchema: GenMessage<LimitStation> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 1);

/**
 * @generated from message v1.ListBetLimitsRequest
 */
export type ListBetLimitsRequest = Message<"v1.ListBetLimitsRequest"> & {
  /**
   * required
   *
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;

  /**
   * @generated from field: string region = 2;
   */
  region: string;
};

/**
 * Describes the message v1.ListBetLimitsRequest.
 * Use `create(ListBetLimitsRequestSchema)` to create a new message.
 */
export const ListBetLimitsRequestSchema: GenMessage<ListBetLimitsRequest> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 2);

/**
 * @generated from message v1.ListBetLimitsResponse
 */
export type ListBetLimitsResponse = Message<"v1.ListBetLimitsResponse"> & {
  /**
   * both "Tất cả" and "Chi tiết" cells
   *
   * @generated from field: repeated v1.BetLimit limits = 1;
   */
  limits: BetLimit[];

  /**
   * every weekday's stations of the region
   *
   * @generated from field: repeated v1.LimitStation stations = 2;
   */
  stations: LimitStation[];

  /**
   * @generated from field: string customer_name = 3;
   */
  customerName: string;

  /**
   * the customer's mode: "all" or "detail"
   *
   * @generated from field: string config_type = 4;
   */
  configType: string;
};

/**
 * Describes the message v1.ListBetLimitsResponse.
 * Use `create(ListBetLimitsResponseSchema)` to create a new message.
 */
export const ListBetLimitsResponseSchema: GenMessage<ListBetLimitsResponse> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 3);

/**
 * UpsertBetLimitsRequest saves the customer's mode and sets the given cells of
 * the region. Cells that are not given are kept.
 *
 * @generated from message v1.UpsertBetLimitsRequest
 */
export type UpsertBetLimitsRequest = Message<"v1.UpsertBetLimitsRequest"> & {
  /**
   * required
   *
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: repeated v1.BetLimit limits = 3;
   */
  limits: BetLimit[];

  /**
   * required: "all" or "detail"; applies to every region
   *
   * @generated from field: string config_type = 4;
   */
  configType: string;
};

/**
 * Describes the message v1.UpsertBetLimitsRequest.
 * Use `create(UpsertBetLimitsRequestSchema)` to create a new message.
 */
export const UpsertBetLimitsRequestSchema: GenMessage<UpsertBetLimitsRequest> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 4);

/**
 * @generated from message v1.UpsertBetLimitsResponse
 */
export type UpsertBetLimitsResponse = Message<"v1.UpsertBetLimitsResponse"> & {
};

/**
 * Describes the message v1.UpsertBetLimitsResponse.
 * Use `create(UpsertBetLimitsResponseSchema)` to create a new message.
 */
export const UpsertBetLimitsResponseSchema: GenMessage<UpsertBetLimitsResponse> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 5);

/**
 * @generated from message v1.MessageOverLimit
 */
export type MessageOverLimit = Message<"v1.MessageOverLimit"> & {
  /**
   * @generated from field: int32 message_id = 1;
   */
  messageId: number;

  /**
   * @generated from field: string content = 2;
   */
  content: string;

  /**
   * @generated from field: string over_message = 3;
   */
  overMessage: string;

  /**
   * @generated from field: string kept_message = 4;
   */
  keptMessage: string;
};

/**
 * Describes the message v1.MessageOverLimit.
 * Use `create(MessageOverLimitSchema)` to create a new message.
 */
export const MessageOverLimitSchema: GenMessage<MessageOverLimit> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 6);

/**
 * @generated from message v1.GetOverLimitMessagesRequest
 */
export type GetOverLimitMessagesRequest = Message<"v1.GetOverLimitMessagesRequest"> & {
  /**
   * @generated from field: int32 customer_id = 1;
   */
  customerId: number;

  /**
   * @generated from field: string region = 2;
   */
  region: string;

  /**
   * @generated from field: google.type.Date calculate_date = 3;
   */
  calculateDate?: Date;
};

/**
 * Describes the message v1.GetOverLimitMessagesRequest.
 * Use `create(GetOverLimitMessagesRequestSchema)` to create a new message.
 */
export const GetOverLimitMessagesRequestSchema: GenMessage<GetOverLimitMessagesRequest> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 7);

/**
 * @generated from message v1.GetOverLimitMessagesResponse
 */
export type GetOverLimitMessagesResponse = Message<"v1.GetOverLimitMessagesResponse"> & {
  /**
   * every message of the day, newest first; over_message is empty when nothing is over
   *
   * @generated from field: repeated v1.MessageOverLimit messages = 1;
   */
  messages: MessageOverLimit[];
};

/**
 * Describes the message v1.GetOverLimitMessagesResponse.
 * Use `create(GetOverLimitMessagesResponseSchema)` to create a new message.
 */
export const GetOverLimitMessagesResponseSchema: GenMessage<GetOverLimitMessagesResponse> = /*@__PURE__*/
  messageDesc(file_v1_bet_limit, 8);

/**
 * BetLimitService manages per-number bet limits (Dư chuẩn).
 *
 * @generated from service v1.BetLimitService
 */
export const BetLimitService: GenService<{
  /**
   * @generated from rpc v1.BetLimitService.ListBetLimits
   */
  listBetLimits: {
    methodKind: "unary";
    input: typeof ListBetLimitsRequestSchema;
    output: typeof ListBetLimitsResponseSchema;
  },
  /**
   * @generated from rpc v1.BetLimitService.UpsertBetLimits
   */
  upsertBetLimits: {
    methodKind: "unary";
    input: typeof UpsertBetLimitsRequestSchema;
    output: typeof UpsertBetLimitsResponseSchema;
  },
  /**
   * @generated from rpc v1.BetLimitService.GetOverLimitMessages
   */
  getOverLimitMessages: {
    methodKind: "unary";
    input: typeof GetOverLimitMessagesRequestSchema;
    output: typeof GetOverLimitMessagesResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_v1_bet_limit, 0);

